export default "__VITE_ASSET__BUknIsbf__"